import { http } from "services/http";

import type { AddressGenSettings, AddressGenSettingsGetRequest } from "models/cryptoaddressgenerator.model";
import type {
  ConversionPlanAddRequest,
  ConversionPlanAddResponse,
  ConversionPlanUpdateRequest,
} from "models/conversion.model";

// Crypto address generator rules (settings). Adding and saving a rule goes through the
// conversion plan endpoints.
export const cryptoAddressGeneratorApi = {
  getSettings: () => http.quiet().get<AddressGenSettings[]>("/api/address-gen-settings"),
  getConfiguration: (data: AddressGenSettingsGetRequest) =>
    http.quiet().post<AddressGenSettings>("/api/address-gen-settings/get", { ...data }),
  addPlan: (data: ConversionPlanAddRequest) =>
    http.quiet().post<ConversionPlanAddResponse>("/api/conversion/add", { ...data }),
  editPlan: (data: ConversionPlanUpdateRequest) =>
    http.quiet().post("/api/conversion/update", { ...data }),
};
